import s from './styles.module.scss'

export const TradeSentimentBar = ({ short, long }: { short: number; long: number }) => {
  const total = short + long
  const longPercent = total === 0 ? 0 : (long / total) * 100

  return (
    <div className={s.container}>
      <div className={s.header}>
        <span>Short</span>
        <span>Long</span>
      </div>

      <div className={s.bar}>
        <div className={s.fill} style={{ width: `${longPercent}%` }} />
      </div>

      <div className={s.values}>
        <span className={s.shortValue}>{short}</span>
        <span className={s.longValue}>{long}</span>
      </div>
    </div>
  )
}
